import Screen from '@amzn/woot-services-vendor-portal-module-vendor-app/src/screens/page-faq'
import React from 'react'

export default () => <Screen />
